import React from 'react'
import PropTypes from 'prop-types'
import apiSubscription from "../features/subscriptions/services/subscription"

const SubscriptionCountContext = React.createContext()

function SubscriptionCountProvider({ children }) {
  const [subscriptionCounts, setSubscriptionCounts] = React.useState({
    users: 'initial',
    candidates: 'initial',
    positions: 'initial',
    textInterviews: 'initial',
    videoInterviews: 'initial',
    inPersonInterviews: 'initial',
    organizations: 'initial',
  })
  const [subscriptionType, setSubscriptionType] = React.useState()

  const contextValue = React.useMemo(
    () => ({ subscriptionCounts, setSubscriptionCounts, subscriptionType }),
    [subscriptionCounts, subscriptionType],
  )

  React.useEffect(() => {
    apiSubscription.getActiveSubscription().then((res) => {
      setSubscriptionCounts({
        users: res?.users || 0,
        candidates: res?.candidates || 0,
        positions: res?.positions || 0,
        textInterviews: res?.textInterviews || 0,
        videoInterviews: res?.videoInterviews || 0,
        inPersonInterviews: res?.inPersonInterviews || 0,
        coverLetterInterviews: res?.coverLetterInterviews || 0,
        organizations: res?.organizations || 0,
      })
      setSubscriptionType(res?.plan?.type)
    })
  }, [])

  return (
    <SubscriptionCountContext.Provider value={contextValue}>
      {children}
    </SubscriptionCountContext.Provider>
  )
}
SubscriptionCountProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export { SubscriptionCountContext, SubscriptionCountProvider }
